export default {
  PURCHASES_INVOICES_LIST: "Invoice list",
  ADD_PURCHASES_INVOICE: "Invoice",
  ADD_PURCHASES_INVOICE_ITEM: "Line",
  PURCHASES_INVOICE_ADDED: "Invoice added",
  OWNER: "Owner",
  EDIT_PURCHASES_INVOICE: "Change an invoice",
  PURCHASES_INVOICE_UPDATED: "Update",
  BILLING_ADDRESS: "Billing address",
  EXPIRATION_TIME: "Deadline",
  ITEM_TYPE: "type",
  SELECT_PRODUCTS: "Choose a product",
  SELECT_SUBSCRIPTIONS: "Choose a registration",
  SELECT_PACKAGES: "Choose a package",
  DELETE_PURCHASES_INVOICE_ITEM: "Delete the line",
  UPDATE_PURCHASES_INVOICE_ITEM: "Edit the line",
  PURCHASES_INVOICE_ITEM_DELETED: "Deleted line",
  PURCHASES_INVOICE_ITEM_ADDED: "Line added",
  PURCHASES_INVOICE_ITEM_EDITED: "Modified line",
  SEND: "Send",
  CANCEL: "Cancel",
  REFUND: "Repay",
  ADD_PAYMENT: "Add a payment",
  PURCHASES_INVOICE_SENT: "Invoice sent",
  SELECT_USERS: "Choose the user",
  SELECT_CUSTOMERS: "Choose",
  SELECT_ORGANIZATIONS: "Choose the Organization",
  SELECT_SUPPLIERS: "Choose the supplier",
  DELETE_THIS_PURCHASES_INVOICE: "Delete this invoice?",
  PURCHASES_INVOICE_DELETED: "Invoice deleted",
  CANCEL_PURCHASES_INVOICE_QUESTION: "Cancel the invoice?",
  PURCHASES_INVOICE_CANCELED: "Invoice canceled",
  RECIPIENT: "RECIPIENT",
  ISSUER: "Issuer",
  VALIDATE: "To validate",
  PURCHASES_INVOICE_VALIDATED: "Validated invoice",
  VIEW_ORDER: "See the order",
  VIEW_PURCHASES_INVOICE: "Purchase invoice",

  CREATED_AT: "Created at",
};
